import { t } from 'i18next';
import { GoSidebarCollapse, GoSidebarExpand } from 'react-icons/go';
import { useShallow } from 'zustand/react/shallow';
import { useWindowSize } from '../../../app/hooks/useWindowSize';
import { useStore } from '../../../app/store';
import { IconButton } from '../IconButton';
import Tooltip from '../Tooltip';

export default function SidebarTrigger() {
  const { isOpen, toggleSidebar } = useStore(
    useShallow((state) => ({
      isOpen: state.sidebar.isOpen,
      toggleSidebar: state.sidebar.toggleSidebar,
    })),
  );

  const { isMobile } = useWindowSize();

  if (isMobile) return;

  return (
    <Tooltip
      text={t(`sidenavbar.tooltip.${isOpen ? 'closeSidebar' : 'openSidebar'}`)}
    >
      <IconButton
        size="md"
        aria-label={t(
          `sidenavbar.tooltip.${isOpen ? 'closeSidebar' : 'openSidebar'}`,
        )}
        onClick={() => toggleSidebar()}
      >
        {isOpen ? (
          <GoSidebarCollapse className="size-5 rotate-180" />
        ) : (
          <GoSidebarExpand className="size-5 rotate-180" />
        )}
      </IconButton>
    </Tooltip>
  );
}
